/* eslint-disable object-shorthand */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addPaginaID } from '~/store/modules/Modulos/actions';
import { Container } from '~/styles/pagesStyle';
import { handleUpdatePage } from '../PaginasServices';
import UpdateCard from './UpdateCard';

const initialForm = {
  name: '',
  idSituacaoCadastral: '',
};

function PaginaUpdate() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [pageData, setPageData] = useState({});
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialForm);
  useEffect(() => {
    setLoading(true);
    async function getData() {
      dispatch(addPaginaID(id));
      await api
        .get(`Pagina/${id}`)
        .then((response) => {
          setLoading(false);
          setPageData(response.data);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados da página, recarregue');
        });
    }
    getData();
  }, [id]);

  async function handleSubmit(e) {
    e.preventDefault();
    const date = new Date().toISOString();
    const usuarioLogado = sessionStorage.getItem('@auth/userName');
    const page = {
      id,
      nome: form.name || pageData.nome,
      idSituacaoCadastral:
        form.situacaoCadastral || pageData.idSituacaoCadastral,
      dataInclusao: date,
      usuario: usuarioLogado,
      excluido: true,
    };
    await handleUpdatePage(setLoading, page);
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {loading ? (
        <Spinner style={{ width: '3rem', height: '3rem', margin: '5% auto' }} />
      ) : (
        <UpdateCard
          pageData={pageData}
          handleSubmit={handleSubmit}
          loading={loading}
          setForm={setForm}
          form={form}
        />
      )}
    </Container>
  );
}

export default PaginaUpdate;
